const en = {
    ABOVE_SESSIONS_REMAIN: 'the above sessions will remain',
    ACTIVE: 'Active',
    ACTIVE_PARTICIPANTS: 'Active Participants',
    ADDITIONAL: 'Additional',
    ADDITIONAL_EXERCISES: 'Additional exercises',
    ADDITIONAL_NOTES: 'Additional notes',
    ADDITIONAL_NOTES_ABOUT_APPEARANCE: 'Additional notes about appearance',
    ADDITIONAL_NOTES_ABOUT_ATTENDANCE: 'Additional notes about attendance',
    ADD_OTHER: 'Add other',
    ALREADY_SCHEDULED: 'already scheduled',
    AND: 'and',
    ANGRY: 'Distressed',
    ARCHIVE: 'Archive',
    ARCHIVED_PARTICIPANTS: 'Archived Participants',
    ASSIGNED_EDUCATIONAL_MATERIAL: 'Assigned educational material',
    ASSIGNED_EXERCISES: 'Assigned exercises',
    ASSIGNED_PROGRAM: 'Assigned program',
    ATTENDANCE: 'Attendance',
    AUDIO_FILE: 'Audio file',
    AVAILABILITY: 'Availability',
    AVAILABILITY_WILL_CHANGE_BUT: 'If you continue, your availability will change for new appointments but',
    BACK_TO_LOGIN: 'Back to login',
    BEHAVIOUR: 'Behavior',
    BIO_INVALID: 'The entered text contains invalid characters. Allowed characters are A-z, 0-9 & - _ . + ! * \' ( ) ,',
    BODY: 'Body',
    BODY_SENS: 'Body sens',
    CALIBRATION: 'Calibration Status',
    CALL: 'Call',
    CALM: 'Content',
    CANCELED: 'Canceled',
    CANCEL_CHANGES: 'Cancel changes',
    CBT_MATERIAL: 'CBT Resources',
    CHANGE: 'Change',
    CHANGE_YOUR_PASSWORD: 'Change your password',
    CLEAR_ALL: 'Clear all',
    COGNITIVE_DISTORTIONS: 'Cognitive Distortions',
    COMPLETED: 'Completed',
    COMPLETE_FIELDS_TO_CONTINUE: 'Complete the attendance field to continue',
    COMPLETED_LOWER: 'completed',
    COMPLETE_EMAIL_TO_SEND_RESET_LINK: 'Complete your email to send you a reset link',
    CONTACT: 'Contact',
    CURRENT_SESSION: 'Current session',
    DATE: 'Date',
    DAY: 'Day',
    DELAYED: 'Delayed',
    DEMOGRAPHICS: 'Demographics',
    DEPLOYMENT: 'Deployment',
    DESCRIPTION: 'Description',
    DESCRIPTION_REQUIRED: 'The description is required',
    DIDNTSHOW: 'Did not show up',
    DID_THE_PARTICIPANT_ATTEND_SESSION: 'Did the participant attend this session?',
    EDUCATION: 'Education',
    EDUCATION_INVALID: 'The entered text contains invalid characters. Allowed characters are A-z, 0-9 & - _ . + ! * \' ( ) ,',
    EDUCATIONAL_MATERIAL: 'Educational Material',
    EDUCATIONAL_MATERIAL_COMPLETED: 'Educational material has been completed',
    EDUCATIONAL_MATERIAL_NOT_COMPLETED: 'Educational material has not been completed',
    ELEMENT: 'element',
    ELEMENTS: 'elements',
    EMAIL: 'Email',
    EMAIL_ADDRESS: 'E-mail address',
    EMAIL_REQUIRED: 'The email is required',
    EMOTION: 'Emotion',
    ENDS: 'ends',
    END_TIME_CANNOT_BE_BEFORE_START_TIME: 'The end time cannot be before the start time',
    ENTER_SESSION: 'Enter Session',
    ERROR: 'Required field',
    EVALUATION: 'Evaluation',
    EVENT: 'Event',
    EXERCISE: 'Exercise',
    EXERCISES: 'Exercises',
    EXERCISES_LOWER: 'exercises',
    EXERCISES_COMPLETE: '{0} {1} {2} {3} this week',
    EXERCISES_COMPLETE_2: '{0} {1} this week',
    FAILED_TO_CHANGE_PASSWORD: 'Your password has failed to be changed',
    FAILED_TO_LOG_IN: 'Invalid email or password',
    FAILED_TO_SAVE_CHANGES: 'Your changes have failed to be saved',
    FAILED_TO_UPLOAD_PICTURE: 'The picture failed to be uploaded',
    FAILED_TO_SEND_EMAIL: 'Your email failed to be sent',
    FEEL_DATA_REPORTS: 'feel data reports',
    FEEL_DATA_REPORT_NOT_YET: "The selected participant does not have Feel Data Reports yet.",
    FEEL_DATA_REPORT_NOT_EIGIBLE: "Feel Data Report is not part of this program.",
    FEEL_DATA_REPORT_ERROR: "Unable to retrieve Feel Data Reports.",
    FIRST_NAME: 'First name',
    FORGOT_PASSWORD: 'Forgot your password?',
    FOR_NEXT_SESSION: 'For next session',
    FRIDAY: 'Friday',
    FRIDAYS: 'Fridays',
    FULL_NAME: 'Full name',
    HAPPY: 'Joyous',
    HELP: 'Help',
    HELPSCOUT: 'Helpscout',
    HOME: 'Home',
    HOUR: 'Hour',
    HOURS_WEARING_TIME:  '{0} hours total wearing time of sensor this week',
    HOW_DID_THE_PARTICIPANT_LOOK: 'How did the participant look?',
    HOW_EMOTIONALLY_AWARE_IS_THE_PARTICIPANT: 'How emotionally aware is the participant?',
    HOW_WOULD_YOU_RATE_PARTICIPANT_COOPERATION: 'How would you rate the participant\'s cooperation and compliance with the program?',
    HOW_WOULD_YOU_RATE_PARTICIPANT_EMOTIONAL_STATE: 'How would you rate the participant\'s overall emotional state?',
    INTENSITY_RATING: 'Intensity rating',
    IN_SOME_SLOTS_TO_BE_REMOVED: 'in some of the slots that you are removing',
    IS_PSYCHIATRIST_REFERRAL_NECESSARY: 'Is a referral to psychiatrist necessary?',
    JOURNAL: 'Journal',
    JOURNALS: 'Journals',
    JOURNALS_COMPLETE: '{0} {1} journals this week',
    KEEP_HERE_EXTRA_NOTES: 'Keep here extra notes..',
    KEEP_HERE_REMINDERS: 'Keep here reminders for the next session..',
    LAST_NAME: 'Last name',
    LAST_SESSION: 'Last session',
    LOGOUT_CONFIRMATION_TEXT: 'Are you sure you want to logout?',
    LOGGED_TIME: 'Logged Time',
    LOG_IN: 'Log In',
    LOG_OUT: 'Log out',
    MINUTES_TIME_IN_APP:  '{0} minutes total time in app this week',
    MONDAY: 'Monday',
    MONDAYS: 'Mondays',
    MOOD_BOOSTERS: 'Mood Boosters',
    MOOD_JOURNALS: 'Mood Journals',
    MORE_WEEK: 'more week',
    MORE_WEEKS: 'more weeks',
    NAME: 'name',
    NAME_INVALID: 'Invalid name format',
    NEW_PASSWORD: 'New password',
    NEW_PASSWORD_NEEDS_TO_BE_RETYPED: 'New password needs to be retyped',
    NEW_PASSWORD_NOT_VALID: 'PASSWORD MUST CONTAIN AT LEAST 8 CHARACTERS INCLUDING AT LEAST 3 OF THE FOLLOWING: A LOWER-CASE LETTER, AN UPPER-CASE LETTER, A NUMBER OR A SPECIAL CHARACTER',
    NEW_PASSWORD_REQUIRED: 'New password is required',
    NEXT_EXERCISES: 'Next exercises',
    NEXT_SESSION: 'Next session',
    NO: 'No',
    NOTE: 'Note',
    NOT_COMPLETED: 'Not completed',
    NOT_REGISTERED_SC: 'This participant is not registered to CBT Resources yet',
    NOT_STARTED: 'Not Started',
    NO_PROGRESS: 'Not completed',
    OF: 'of',
    OK: 'Ok',
    OLD_PASSWORD: 'Old password',
    OLD_PASSWORD_REQUIRED: 'Old password is required',
    OLD_PASSWORD_WRONG: 'The old password entered is incorrect.',
    ONTIME: 'On time',
    OPEN: 'Open',
    OUT_OF: 'out of',
    PAGE_NOT_FOUND: 'What you want is not here',
    PAGE_TITLE: 'Feel',
    PARTICIPANT_ID: 'PARTICIPANT ID',
    PARTICIPANT: 'Participant',
    PASSWORD: 'Password',
    PASSWORDS_NOT_MATCH: 'Passwords do not match',
    PASSWORD_DO_NOT_MATCH: 'The password does not match',
    PASSWORD_REQUIRED: 'The password is required',
    PASTE_LINK_PLACEHOLDER: 'Paste the exercise\'s link..',
    PERFORMANCE: 'Performance',
    PHONE: 'Phone',
    PHONE_NUMBER: 'Phone Number',
    PHONE_INVALID: 'Invalid phone number',
    PHONE_REQUIRED: 'Phone is required',
    PHYSICAL_SENSATIONS: 'Physical sensations',
    PREVIOUS_EXERCISES: 'Previous exercises',
    PRIVACY_NOTICE: 'Privacy notice',
    PROCEED_WITH_THE_CHANGES: 'Are you sure you want to proceed with the changes?',
    PROGRAM_TYPE: 'Program type',
    PUBLISHED: 'published',
    REFERRAL: 'Referred - previous PID',
    REMINDER: 'Reminder',
    RESET_HERE: 'Reset here',
    RETYPE_NEW_PASSWORD: 'Retype new password',
    SAD: 'Sad',
    SATURDAY: 'Saturday',
    SATURDAYS: 'Saturdays',
    SAVE: 'Save',
    SAVE_CHANGES: 'Save changes',
    SEE_ALL: 'See all',
    SELECT_VALUE: 'Select value',
    SEND: 'Send',
    SEND_EMAIL: 'Send Email',
    SENSOR_TIME_IN_APP: 'Time in app',
    SENSOR_WEARING_TIME: 'Sensor wearing time',
    SESSION: 'Session',
    SESSIONS: 'sessions',
    SESSION_NOTES: 'Session notes',
    SET_AVAILABILITY: 'Set availability',
    SET_GOAL: 'Set goal',
    SHOWING: 'Showing',
    SLOTS_CANNOT_OVERLAP: 'Availability slots cannot overlap each other',
    SOMETHING_ABOUT_YOU: 'Something about you',
    STATUS: 'Status',
    SUBJECT: 'Subject',
    SUNDAY: 'Sunday',
    SUNDAYS: 'Sundays',
    SURNAME_INVALID: 'Invalid surname format',
    TARGET_COMPLETED: 'Completed',
    THIS_WEEK: 'this week',
    THOUGHTS: 'Thoughts',
    THURSDAY: 'Thursday',
    THURSDAYS: 'Thursdays',
    TIME: 'Emotion Time',
    TIMEZONE: 'Timezone',
    TITLE: 'Title',
    TITLE_REQUIRED: 'The title is required',
    TO: 'to',
    TODAY: 'Today',
    TODAY_SESSIONS: 'Today\'s Sessions',
    TRIGGER_EVENT: 'Trigger event',
    TRIGGER: 'Trigger',
    TUESDAY: 'Tuesday',
    TUESDAYS: 'Tuesdays',
    UNSET_DIAGNOSIS: 'UNSET',
    UPCOMING_SESSION: 'Upcoming session',
    URL_ADDRESS: 'URL Address',
    WARNING: 'Warning',
    WEDNESDAY: 'Wednesday',
    WEDNESDAYS: 'Wednesdays',
    WEEK: 'Week',
    WE_HAVE_SENT_YOU_A_PASSWORD_RESET_EMAIL: 'We have sent you an email to reset your password.',
    WHAT_IS_THE_PROGRESS_TOWARDS_THE_SET_GOAL: 'What\'s the progress towards our set goal?',
    WILL_CONTINUE: 'remain as scheduled',
    WRITE_DESIRED_GOAL: 'Write the desired goal of this participant..',
    WRITE_HERE_THE_EXERCISE_DESCRIPTION: 'Write here the exercise description..',
    WRITE_HERE_THE_EXERCISE_TITLE: 'Write here the exercise title..',
    WRISTBAND: 'Wristband',
    YES: 'Yes',
    YOUR_CHANGES_HAVE_BEEN_SAVED: 'Your changes have been saved',
    YOUR_EMAIL_HAS_BEEN_SENT: 'Your email has been sent',
    YOUR_CHANGES_HAVE_BEEN_SAVED_BUT_SESSIONS_WITH: 'Your changes have been saved but your sessions with',
    YOUR_WORDS: 'Participant\'s words',
    YOU_HAVE_SESSIONS: 'You have sessions'
}
export default en



// WEBPACK FOOTER //
// ./src/languages/en.js